import { render, staticRenderFns } from "./DrawerHubTeam.vue?vue&type=template&id=5b63d712"
import script from "./DrawerHubTeam.vue?vue&type=script&lang=js"
export * from "./DrawerHubTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports